import { Injectable } from '@angular/core';

import {ParagraphLogoSliderData,ParagraphNewsTickerItemData } from '@generated/content';
import {

  MediaImageData,

} from '@generated/content';
import { TMediaNodeType } from '@interfaces/media';

import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { NewsTickerItem } from '@interfaces/config/cms-components/news-ticker-item-config';


import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';

import {  CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { CmsComponentConfig, TextMediaBox } from '@interfaces/config';

import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';


@Injectable({ providedIn: 'root' })
export class NewsTickerComponentResolver extends BaseComponentResolver {
  static override instance: NewsTickerComponentResolver;
  private readonly componentType = NewsTickerItem.TypeEnum;

  static getInstance(): NewsTickerComponentResolver {
 
    return (NewsTickerComponentResolver.instance ||= new NewsTickerComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphNewsTickerItemData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<NewsTickerItem.ComponentConfig> | null {
    if (!node) {
      return null;
    }

 

    this.nodePageData = nodePageData;
    //uri: string;
    //linkText:string;
    //newsTitle:string
   
   let newsItems = [{newsTitle: node.attributes.field_news_ticker_text.value,uri:node.attributes.field_link_sh.uri,linkText:node.attributes.field_link_sh.title}];

   return {
      componentType: this.componentType,
      config: {
        
        newsItems
        
      },
    };


    
  }




  private getColumns(node: ParagraphNewsTickerItemData):  TextMediaBox.MediaImageConfig[] | null {
  
    console.log("XXX::",node);

    return null;


  }


  private buildColumnConfig(node: any): TextMediaBox.MediaImageConfig | null {
    const { id, type } = node;
  
    if (!(id && node)) {
      return null;
    }

 
    const columnNode = this.getNode<MediaImageData>(id, type);


    if (!columnNode) {
      return null;
    }

     const media = this.getMediaConfig(columnNode);

    return  media;


  }



      private getMediaConfig(
        node: MediaImageData
      ):
         TextMediaBox.MediaImageConfig
        {
          
      
 
        const { type, id } = node;
    
        
      
        switch (type) {
          case MediaImageData.TypeEnum.MediaImage:
            const { dataUrls, metas } = this.getMediaDataUrls(id, type as TMediaNodeType, null, true);
            return {
              type: MediaTypesEnum.IMAGE,
              dataUrls,
              metas,
              fill: false,
              sizes: MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.CARDS),
            };
    
         
    
          default:
            return null;
        }
      }
    
 

    


}
